/**
 * @generated SignedSource<<de5f47059abe00b5987b3d8eb8c60d05>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { InlineFragment, ReaderInlineDataFragment } from 'relay-runtime';
export type Currency = "AUD" | "CAD" | "CHF" | "DKK" | "EUR" | "GBP" | "JPY" | "MXN" | "NOK" | "SEK" | "USD" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type applePayCheckout_transaction$data = {
  readonly buyerChargeCurrency: Currency | null;
  readonly buyerInvoice: {
    readonly totalAmount: {
      readonly convertedAmountList: ReadonlyArray<{
        readonly amount: number | null;
        readonly currency: Currency | null;
      } | null> | null;
    } | null;
  } | null;
  readonly " $fragmentType": "applePayCheckout_transaction";
};
export type applePayCheckout_transaction$key = {
  readonly " $data"?: applePayCheckout_transaction$data;
  readonly " $fragmentSpreads": FragmentRefs<"applePayCheckout_transaction">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "applePayCheckout_transaction"
};

(node as any).hash = "85b38e0834c84ca32bbde99d85b37506";

export default node;
